import React, { useState, useRef, useEffect } from "react";
import style from "./commentModal.module.scss"
import Modal from "../../Modal/Modal"
import Button from "../../Button/button";
import MobilePagination from "../../mobilePagination/mobilePagination"

const CommentModal = (props) => {

    const [comment, setComment] = useState({ text: '', addComment: false, page: (props.data && props.data.page ? props.data.page : 1) })

    const determineDate = date => {
        let current = new Date(date).toLocaleDateString('fa-IR')
        return current
    }

    const handleAddComment = e => {
        let tmp = comment
        tmp.text = e.target.value
        setComment({ ...tmp })
    }

    const postComment = async () => {
        let res = await props.addComment({ tweetId: props.data._id, content: comment.text })
        if (res && res.data) {
            await props.getComments(props.data, 1)
            let tmp = comment
            tmp.addComment = false
            tmp.page = 1
            tmp.text = ''
            setComment({ ...tmp })
        }
    }

    const handlePage = async (number) => {
        let tmp = comment
        tmp.page = number
        setComment({ ...tmp })
        await props.getComments(props.data, number)
    }

    const closeModal = () => {
        let tmp = comment
        tmp.text = ''
        tmp.addComment = false
        tmp.page = 1
        setComment({ ...tmp })
        props.parentClose()
    }

    return (
        <Modal
            tag='commentModal'
            value={props.value}
            title='دیدگاه‌ها'
            parentClose={closeModal}
        >
            <div className={style.wrapper}>
                <div className={style.innerWrapper}>
                    <div className={style.userComment}>
                        <div className={style.header}>
                            <div className={style.profile}>
                                <p className={style.text}>{typeof props.data != 'undefined' && props.data && props.data.name ? props.data.name : 'موبیشایی'}</p>
                            </div>
                            <div className={style.dateWrapper}>{determineDate(props.data ? props.data.createDate : new Date())}</div>
                        </div>

                        <div className={style.textWrapper}>
                            <p>{props.data ? props.data.content : ''}</p>
                        </div>
                    </div>

                    <div
                        className={style.addMoreComment}
                        onClick={() => setComment({ ...comment, addComment: !comment.addComment })}
                    >
                        <div className={style.addIcon}>i</div>
                        <div className={style.addIconText}>افزودن دیدگاه</div>
                    </div>

                    {comment.addComment && <>
                        <textarea
                            value={comment.text}
                            className={style.textWrapperStyle}
                            onChange={e => handleAddComment(e)}
                            placeholder="دیدگاه خود را اینجا به اشتراک بگذارید"
                        ></textarea>
                        <div className={style.buttonWrapper}>
                            <div className={style.postBtn}>
                                <Button
                                    tag="postButton"
                                    disabled={comment.text != '' ? false : true}
                                    type="solid"
                                    label="اشتراک‌گذاری"
                                    onclick={postComment}
                                />
                            </div>
                        </div>
                    </>}

                    {props.data && props.data.comments && props.data.comments.length > 0 && <><div className={style.commentWrapper}>
                        {props.data.comments.map((commentVal, commentIndex) => <div
                            key={`commentIndex_${commentIndex}`}
                            className={style.commentItem}
                        >
                            {commentVal.content}
                        </div>)}
                    </div>
                        <div className={style.paginationWrapper}>
                            <MobilePagination
                                currentPage={comment.page}
                                pageCount={props.data.totalPages ? props.data.totalPages : 10}
                                setPage={handlePage}
                            />
                        </div>
                    </>}
                </div>
            </div>
        </Modal>
    );
}

export default CommentModal;
